import iconv from "iconv-lite";

export function converter(text, code, convertercode) {
  var returnValue = "";
  var enCode = "";
  switch (code) {
    case 'ISO_IR 100':
      enCode = "iso-8859-1";
      break;
    case 'ISO_IR 101':
      enCode = "iso-8859-2";
      break;
    case 'ISO_IR 109':
      enCode = "iso-8859-3";
      break;
    case 'ISO_IR 110':
      enCode = "iso-8859-4";
      break;
    case 'ISO_IR 144':
      enCode = "iso-8859-5";
      break;
    case 'ISO_IR 127':
      enCode = "iso-8859-6";
      break;
    case 'ISO_IR 126':
      enCode = "iso-8859-71";
      break;
    case 'ISO_IR 138':
      enCode = "iso-8859-8";
      break;
    case 'ISO_IR 148':
      enCode = "iso-8859-9";
      break;
    case 'ISO_IR 192':
      enCode = "utf-8";
      break;
    case 'GB18030':
      enCode = "gb18030";
      break;
    case 'GBK':
      enCode = "gbk";
      break;
    case 'IR 166':
      enCode = "tis620";
      break;
  }


  const buf = iconv.encode(text, enCode);
  returnValue = iconv.decode(buf, convertercode);
  return returnValue;
}
